import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.chart');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-chart',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.chart/view.scss */
:host {
  display: block;
  height: 100%;
}

.chart-workspace {
  position: relative;
  background: #f3f6f9;
}

.chart-main-shell {
  min-width: 0;
}

.chart-header {
  padding: 10px 14px 0;
  border-bottom: 1px solid #d7e0ea;
  background: linear-gradient(180deg, #f8fafc 0%, #f3f6f9 100%);
  flex-shrink: 0;
}

.chart-header-band {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  padding-bottom: 10px;
}

.chart-patient-card {
  display: flex;
  gap: 12px;
  min-width: 0;
  flex: 1;
}

.chart-patient-avatar {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  font-size: 12px;
  font-weight: 800;
  color: #334155;
  flex-shrink: 0;
}

.chart-patient-copy {
  min-width: 0;
  flex: 1;
}

.chart-patient-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.chart-patient-name {
  font-size: 18px;
  line-height: 1.1;
  font-weight: 800;
  color: #0f172a;
}

.chart-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 700;
}

.chart-patient-meta {
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
}

.chart-patient-headline {
  margin-top: 6px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
  color: #0f172a;
}

.chart-patient-support {
  margin-top: 3px;
  font-size: 11px;
  line-height: 1.4;
  color: #64748b;
}

.chart-header-actions {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.chart-context-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 1px;
  background: #d7e0ea;
  border-top: 1px solid #d7e0ea;
}

.chart-context-cell {
  min-width: 0;
  background: #ffffff;
  padding: 8px 10px;
}

.chart-context-cell--wide {
  grid-column: span 2;
}

.chart-context-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #64748b;
}

.chart-context-value {
  display: block;
  margin-top: 3px;
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chart-meta-bar {
  display: none;
}
.chart-meta-bar .meta-item {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
}
.chart-meta-bar .meta-item strong {
  font-weight: 700;
  color: #334155;
}

.chart-section-ribbon {
  display: flex;
  align-items: center;
  gap: 0;
  padding: 0 14px;
  border-bottom: 1px solid #d7e0ea;
  background: #eef3f7;
  flex-shrink: 0;
  overflow-x: auto;
  scrollbar-width: none;
}
.chart-section-ribbon::-webkit-scrollbar {
  display: none;
}

.chart-section-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  font-size: 11px;
  font-weight: 700;
  color: #475569;
  white-space: nowrap;
  border: 0;
  border-right: 1px solid #d7e0ea;
  background: #f8fafc;
  transition: background-color 0.15s, color 0.15s;
}
.chart-section-tab:hover {
  color: #0f172a;
  background: #ffffff;
}
.chart-section-tab.active {
  color: #0f172a;
  background: #ffffff;
  box-shadow: inset 0 -2px 0 #2563eb;
}

.chart-section-index {
  font-size: 10px;
  font-weight: 800;
  color: #94a3b8;
}

.chart-section-label {
  color: inherit;
}

.chart-section-meta {
  margin-left: auto;
  font-size: 10px;
  font-weight: 700;
}

.chart-section-meta--done {
  color: #047857;
}

.chart-section-meta--pending {
  color: #94a3b8;
}

.chart-content-stage {
  display: block;
  scroll-padding-top: 48px;
  background: transparent;
}

.chart-editor-topline,
.chart-tab-stack {
  width: min(1180px, 100%);
  margin-inline: auto;
}

.chart-editor-topline {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  border: 1px solid #d7e0ea;
  border-top: 0;
  background: rgba(255, 255, 255, 0.96);
}

.chart-editor-summary {
  min-width: 0;
  flex: 1;
}

.chart-editor-kicker {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.chart-editor-title-row {
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.chart-editor-title {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
}

.chart-editor-counter {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
}

.chart-editor-guide {
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
}

.chart-editor-tools {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.chart-tab-stack > .bg-white {
  border: 1px solid #e2e8f0;
  border-radius: 4px !important;
  box-shadow: none;
  padding: 12px !important;
  margin-bottom: 8px;
}

.chart-tab-stack > .bg-white > .text-sm.font-bold.text-gray-800 {
  margin: -12px -12px 10px !important;
  padding: 8px 12px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #475569 !important;
}

.chart-tab-stack > .bg-white > .flex.items-center.justify-between.mb-4,
.chart-tab-stack > .bg-white > .flex.items-center.justify-between.mb-3 {
  margin: -12px -12px 10px !important;
  padding: 8px 12px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.chart-tab-stack > .bg-white > .flex.items-center.justify-between.mb-4 .text-sm.font-bold.text-gray-800,
.chart-tab-stack > .bg-white > .flex.items-center.justify-between.mb-3 .text-sm.font-bold.text-gray-800 {
  margin: 0 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #475569 !important;
}

.chart-tab-stack textarea,
.chart-tab-stack input,
.chart-tab-stack select {
  font-size: 12px;
  padding: 6px 10px !important;
  border-color: #cbd5e1 !important;
  border-radius: 4px !important;
  background: #ffffff !important;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.chart-tab-stack textarea:focus,
.chart-tab-stack input:focus,
.chart-tab-stack select:focus {
  border-color: #059669 !important;
  box-shadow: 0 0 0 2px rgba(5, 150, 105, 0.1);
}

.chart-tab-stack label {
  margin-bottom: 2px !important;
}

.chart-tab-stack .gap-6 {
  gap: 0.75rem !important;
}

.chart-tab-stack .gap-5 {
  gap: 0.625rem !important;
}

.chart-tab-stack .gap-4 {
  gap: 0.5rem !important;
}

.chart-tab-stack .gap-3 {
  gap: 0.5rem !important;
}

.chart-tab-stack .mb-4 {
  margin-bottom: 0.5rem !important;
}

.chart-tab-stack .mb-3 {
  margin-bottom: 0.5rem !important;
}

.diagnostic-stage {
  border: 1px solid #e2e8f0 !important;
  border-radius: 4px !important;
  padding: 12px !important;
  background: #f8fafc !important;
  box-shadow: none !important;
}

.diagnostic-part {
  transition: fill 0.15s, stroke 0.15s;
}

.diagnostic-part:hover {
  filter: drop-shadow(0 1px 4px rgba(16, 185, 129, 0.3));
}

.chart-ai-scrim {
  position: absolute;
  inset: 0;
  z-index: 28;
  background: rgba(15, 23, 42, 0.15);
}

.chart-ai-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 30;
  min-width: 280px;
  max-width: min(480px, 44vw);
  border-left: 1px solid #d7e0ea;
  background: #eef3f7;
}

.chart-ai-resizer {
  position: absolute;
  left: -3px;
  top: 0;
  bottom: 0;
  width: 5px;
  cursor: col-resize;
  z-index: 5;
}
.chart-ai-resizer::before {
  content: "";
  position: absolute;
  left: 2px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: #e2e8f0;
}

body.chart-chat-resizing,
body.chart-chat-resizing * {
  cursor: col-resize !important;
  user-select: none !important;
}

.chart-ai-panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid #d7e0ea;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
}

.chart-ai-panel-copy {
  min-width: 0;
  flex: 1;
}

.chart-ai-panel-kicker {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.chart-ai-panel-title {
  margin-top: 2px;
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
}

.chart-ai-panel-sub {
  margin-top: 3px;
  font-size: 11px;
  line-height: 1.4;
  color: #64748b;
}

.chart-ai-panel-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.chart-ai-tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-bottom: 1px solid #d7e0ea;
  background: #ffffff;
}

.chart-ai-tab {
  padding: 4px 8px;
  border: 1px solid #d7e0ea;
  background: #f8fafc;
  font-size: 11px;
  font-weight: 700;
  color: #475569;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;
}
.chart-ai-tab:hover {
  background: #ffffff;
  border-color: #94a3b8;
}

.chart-ai-tab--active {
  background: #0f172a;
  border-color: #0f172a;
  color: #ffffff;
}

.chart-ai-panel-body {
  height: 100%;
  overflow: auto;
  padding: 12px;
  background: #f3f6f9;
}

.chart-ai-summary {
  border: 1px solid #d7e0ea;
  background: #ffffff;
  padding: 10px;
}

.chart-ai-focus {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.chart-ai-recommendation-card {
  width: 100%;
  border: 1px solid #d7e0ea;
  background: #ffffff;
  padding: 10px;
  text-align: left;
  transition: background-color 0.15s, border-color 0.15s;
}
.chart-ai-recommendation-card:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.chart-ai-pending-note {
  border: 1px solid #fcd34d;
  background: #fff8e7;
  padding: 10px;
}

.chart-ai-pending-card {
  border: 1px solid #d7e0ea;
  background: #ffffff;
  padding: 10px;
}

.chart-ai-empty {
  border: 1px dashed #d7e0ea;
  background: #ffffff;
  padding: 24px 16px;
  text-align: center;
  font-size: 11px;
  color: #94a3b8;
}

.chart-chat-stage {
  background: #f4f7fa;
}

.chart-chat-user-bubble {
  max-width: 85%;
  border: 1px solid #1e293b;
  background: #1e293b;
  padding: 10px 12px;
  font-size: 13px;
  color: #ffffff;
}

.chart-chat-assistant-bubble {
  border: 1px solid #d7e0ea;
  background: #ffffff;
  padding: 10px 12px;
  font-size: 13px;
}

.chart-ai-suggestion-card {
  border: 1px solid #d7e0ea;
  background: #ffffff;
  padding: 10px;
}

.chart-ai-suggestion-card--prescription {
  border-left: 3px solid #d97706;
}

.chart-ai-suggestion-card--warning {
  border-left: 3px solid #f59e0b;
}

.chart-ai-suggestion-card--critical {
  border-left-color: #dc2626;
  background: #fff7f7;
}

.chart-ai-suggestion-card--chart {
  border-left: 3px solid #059669;
}

.chart-chat-compose {
  border-top: 1px solid #d7e0ea;
  background: #ffffff;
  padding: 10px 12px;
}

.chart-sheet-panel {
  animation: sheetRise 0.25s ease-out;
  border-radius: 6px !important;
}

.chart-sheet-header {
  background: #1e293b !important;
}

.chart-sheet-sidebar {
  background: #f8fafc;
  padding: 12px !important;
}

.chart-sheet-body {
  background: #f1f5f9;
  padding: 12px !important;
}

.chart-sheet-group {
  border-radius: 4px !important;
  padding: 10px !important;
}

.chart-sheet-card {
  border-radius: 4px !important;
  padding: 10px !important;
  background: #fff !important;
  box-shadow: none !important;
}

.chart-action-bar {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  box-shadow: none;
}

.chat-md-content {
  line-height: 1.6;
}
.chat-md-content .chat-h2 {
  font-size: 13px;
  font-weight: 700;
  margin: 6px 0 3px;
}
.chat-md-content .chat-h3 {
  font-size: 12px;
  font-weight: 700;
  margin: 6px 0 3px;
}
.chat-md-content .chat-h4 {
  font-size: 11px;
  font-weight: 600;
  margin: 4px 0 2px;
  color: #374151;
}
.chat-md-content .chat-ul, .chat-md-content .chat-ol {
  padding-left: 14px;
  margin: 3px 0;
}
.chat-md-content .chat-li {
  list-style: disc;
  margin: 1px 0;
}
.chat-md-content .chat-oli {
  list-style: decimal;
  margin: 1px 0;
}
.chat-md-content .chat-code {
  background: #1e293b;
  color: #e2e8f0;
  border-radius: 4px !important;
  padding: 6px 10px;
  margin: 4px 0;
  font-size: 11px;
  overflow-x: auto;
  white-space: pre-wrap;
}
.chat-md-content .chat-inline-code {
  background: #f1f5f9;
  color: #0f766e;
  padding: 1px 4px;
  border-radius: 2px !important;
  font-size: 11px;
}
.chat-md-content .chat-table {
  width: 100%;
  border-collapse: collapse;
  margin: 4px 0;
  font-size: 11px;
}
.chat-md-content .chat-table th {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 3px 6px;
  text-align: left;
  font-weight: 600;
}
.chat-md-content .chat-table td {
  border: 1px solid #e2e8f0;
  padding: 3px 6px;
}
.chat-md-content .chat-hr {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 6px 0;
}
.chat-md-content strong {
  font-weight: 600;
}

.chart-scroll-pane,
#chat-messages {
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.5) transparent;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes sheetRise {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-fadeIn {
  animation: fadeIn 0.2s ease-out;
}

@media (max-width: 1279px) {
  .chart-editor-topline, .chart-tab-stack {
    width: 100%;
  }
  .chart-header-band {
    flex-direction: column;
  }
  .chart-header-actions {
    justify-content: flex-start;
  }
  .chart-context-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .chart-context-cell--wide {
    grid-column: span 2;
  }
}
@media (max-width: 1023px) {
  .chart-ai-panel {
    width: min(100vw, 400px) !important;
    max-width: 100vw;
  }
  .chart-ai-resizer {
    display: none;
  }
  .chart-editor-topline {
    flex-direction: column;
  }
  .chart-editor-tools {
    justify-content: flex-start;
  }
}
@media (max-width: 767px) {
  .chart-context-grid {
    grid-template-columns: 1fr;
  }
  .chart-context-cell--wide {
    grid-column: span 1;
  }
  .chart-patient-name {
    font-size: 16px;
  }
}`],
})
export class PageChartComponent implements OnInit, OnDestroy {
    public visitId: string = '';
    public visit: any = {};
    public patient: any = {};
    public chart: any = {};
    public history: any[] = [];
    public prescriptions: any[] = [];
    public chartTab: string = 'subjective';

    // AI 채팅
    public showChat: boolean = false;
    public aiPanelTab: string = 'recommendations';
    public showChatTranscript: boolean = false;
    public chatPanelWidth: number = 400;
    public readonly chatPanelDefaultWidth: number = 400;
    public readonly chatPanelMinWidth: number = 320;
    public chatPanelResizing: boolean = false;
    public chatSession: any = null;
    public chatMessages: any[] = [];
    public chatInput: string = '';
    public chatLoading: boolean = false;
    private abortController: AbortController | null = null;
    public streamingContent: string = '';
    public chartUpdateNotice: string = '';
    private chartUpdateTimer: any = null;
    public clinicalPhase: string = 'recommendation';

    public recommendationLoading: boolean = false;
    public recommendationNotice: string = '';
    public recommendationPanel: any = {
        summary: '',
        additional_questions: [],
        survey_templates: [],
        examinations: [],
        key_items: [],
        branch_directions: [],
        candidate_conditions: [],
    };
    public recommendationSections: any[] = [
        {
            key: 'additional_questions',
            label: '추가 질문',
            short: 'Q',
            surfaceClass: 'border-slate-200 bg-white',
            badgeClass: 'bg-slate-100 text-slate-700',
        },
        {
            key: 'survey_templates',
            label: '설문 템플릿',
            short: 'S',
            surfaceClass: 'border-slate-200 bg-white',
            badgeClass: 'bg-slate-100 text-slate-700',
        },
        {
            key: 'examinations',
            label: '검사법',
            short: 'E',
            surfaceClass: 'border-slate-200 bg-white',
            badgeClass: 'bg-slate-100 text-slate-700',
        },
        {
            key: 'key_items',
            label: '감별 핵심 항목',
            short: 'K',
            surfaceClass: 'border-slate-200 bg-white',
            badgeClass: 'bg-slate-100 text-slate-700',
        },
        {
            key: 'branch_directions',
            label: '분기 방향',
            short: 'B',
            surfaceClass: 'border-slate-200 bg-white',
            badgeClass: 'bg-slate-100 text-slate-700',
        },
        {
            key: 'candidate_conditions',
            label: '후보 질환',
            short: 'D',
            surfaceClass: 'border-slate-200 bg-white',
            badgeClass: 'bg-slate-100 text-slate-700',
        },
    ];
    public chartProgressSections: any[] = [
        { key: 'subjective', label: '주소증', description: '주소증, 현병력, 진단' },
        { key: 'objective', label: '객관소견', description: '통증 맵, 이학적 검사' },
        { key: 'tongue', label: '설진', description: '설색, 설태, 설형' },
        { key: 'pulse', label: '맥진', description: '맥상, 맥박수' },
        { key: 'abdominal', label: '복진', description: '복부 분획 소견' },
        { key: 'pattern', label: '변증', description: '변증, 사상체질' },
        { key: 'plan', label: '치료계획', description: '치법, 계획, 주의사항' },
    ];
    public chartSectionGroups: any[] = [
        { key: 'intake', label: '문진', description: '주호소와 객관소견을 먼저 정리합니다.' },
        { key: 'exam', label: '사진·진찰', description: '설진, 맥진, 복진으로 근거를 쌓습니다.' },
        { key: 'plan', label: '치료', description: '변증, 계획, 처방으로 결론을 정리합니다.' },
    ];
    public chartNavigationSections: any[] = [
        { key: 'subjective', label: '주소증', description: '주호소, 현병력, 진단', group: 'intake', short: '01', chipClass: 'bg-slate-100 text-slate-700', surfaceClass: 'border-slate-200 bg-white' },
        { key: 'objective', label: '객관소견', description: '통증 맵, 이학적 검사', group: 'intake', short: '02', chipClass: 'bg-slate-100 text-slate-700', surfaceClass: 'border-slate-200 bg-white' },
        { key: 'tongue', label: '설진', description: '설색, 설태, 설형', group: 'exam', short: '03', chipClass: 'bg-slate-100 text-slate-700', surfaceClass: 'border-slate-200 bg-white' },
        { key: 'pulse', label: '맥진', description: '맥상, 맥박수', group: 'exam', short: '04', chipClass: 'bg-slate-100 text-slate-700', surfaceClass: 'border-slate-200 bg-white' },
        { key: 'abdominal', label: '복진', description: '복부 분획 소견', group: 'exam', short: '05', chipClass: 'bg-slate-100 text-slate-700', surfaceClass: 'border-slate-200 bg-white' },
        { key: 'pattern', label: '변증', description: '변증, 사상체질', group: 'plan', short: '06', chipClass: 'bg-slate-100 text-slate-700', surfaceClass: 'border-slate-200 bg-white' },
        { key: 'plan', label: '치료계획', description: '치법, 계획, 주의사항', group: 'plan', short: '07', chipClass: 'bg-slate-100 text-slate-700', surfaceClass: 'border-slate-200 bg-white' },
        { key: 'prescription', label: '처방', description: '처방, 시술, 투약 계획', group: 'plan', short: '08', chipClass: 'bg-slate-100 text-slate-700', surfaceClass: 'border-slate-200 bg-white' },
    ];
    public showChartNavigator: boolean = false;
    public selectedRecommendationIds: string[] = [];
    public recommendationChatContext: any = {
        priority: 'chat_first',
        active_tab: '',
        conversation: [],
        last_user_message: '',
        last_ai_response: '',
        last_phase: '',
    };
    private recommendationRequestVersion: number = 0;
    private readonly chatResizeMoveHandler = (event: MouseEvent) => this.onChatResize(event);
    private readonly chatResizeUpHandler = () => this.stopChatResize();

    // AI 제안 수정 모달
    public showModifyModal: boolean = false;
    public modifyMsg: any = null;
    public modifyFields: any = {};
    public modifyFieldKeys: string[] = [];

    // 처방 편집
    public showPrescription: boolean = false;
    public prescForm: any = {};
    public herbSearch: string = '';
    public herbResults: any[] = [];
    public formulaSearch: string = '';
    public formulaResults: any[] = [];

    // 진단코드 검색
    public diagSearch: string = '';
    public diagResults: any[] = [];

    // 경혈 검색
    public acupointSearch: string = '';
    public acupointResults: any[] = [];

    // JSON 필드 편집용
    public tongueData: any = {};
    public pulseData: any = {};
    public abdominalData: any = {};
    public patternData: any = {};
    public rosData: any = {};

    // ── 인체 통증 지도 ──
    public bodyView: string = 'front';
    public bodyPainData: any = {};
    public selectedBodyRegion: string = '';
    public selectedBodyRegions: any[] = [];
    public bodyRegionsFront = [
        { id: 'head', label: '머리' },
        { id: 'neck', label: '목' },
        { id: 'left_shoulder', label: '좌 어깨' },
        { id: 'right_shoulder', label: '우 어깨' },
        { id: 'chest', label: '흉부' },
        { id: 'left_arm', label: '좌 상지' },
        { id: 'right_arm', label: '우 상지' },
        { id: 'upper_abdomen', label: '상복부' },
        { id: 'lower_abdomen', label: '하복부' },
        { id: 'left_leg', label: '좌 하지' },
        { id: 'right_leg', label: '우 하지' },
    ];
    public bodyRegionsBack = [
        { id: 'back_head', label: '후두부' },
        { id: 'back_neck', label: '뒷목' },
        { id: 'upper_back', label: '상배부' },
        { id: 'mid_back', label: '중배부' },
        { id: 'lower_back', label: '요부(허리)' },
        { id: 'left_hip', label: '좌 둔부' },
        { id: 'right_hip', label: '우 둔부' },
        { id: 'left_posterior_leg', label: '좌 후면 하지' },
        { id: 'right_posterior_leg', label: '우 후면 하지' },
    ];

    // ── 설진 시각화 ──
    public tongueColors = [
        { value: '담홍', label: '담홍(淡紅)', hex: '#F4A0A0', desc: '정상' },
        { value: '담백', label: '담백(淡白)', hex: '#F0D0D0', desc: '기혈허·양허' },
        { value: '홍', label: '홍(紅)', hex: '#E05050', desc: '열증·음허' },
        { value: '강', label: '강(絳)', hex: '#A01030', desc: '열입영혈' },
        { value: '자', label: '자(紫)', hex: '#9B3B8B', desc: '어혈·한응' },
        { value: '청', label: '청(靑)', hex: '#5A8A9B', desc: '한응·어혈' },
    ];
    public tongueCoatings = [
        { value: '백태', label: '백태(白苔)', hex: '#FFFFFFCC', desc: '표증·한증' },
        { value: '황태', label: '황태(黃苔)', hex: '#E8D44DCC', desc: '열증·리증' },
        { value: '회흑태', label: '회흑태(灰黑苔)', hex: '#666666AA', desc: '리증 중증' },
        { value: '박태', label: '박태(薄苔)', hex: '#FFFFFF66', desc: '경병' },
        { value: '후태', label: '후태(厚苔)', hex: '#D0C8B0CC', desc: '중병' },
        { value: '무태', label: '무태(無苔)', hex: 'transparent', desc: '위기허·음허' },
    ];
    public tongueShapes = [
        { value: '정상', label: '정상', icon: '〇' },
        { value: '비대', label: '비대(胖大)', icon: '◉' },
        { value: '수박', label: '수박(瘦薄)', icon: '◇' },
        { value: '치흔', label: '치흔(齒痕)', icon: '⚙' },
        { value: '열문', label: '열문(裂紋)', icon: '‖' },
        { value: '망자', label: '망자(芒刺)', icon: '△' },
    ];
    public tongueMoistures = [
        { value: '윤', label: '윤(潤)', desc: '촉촉함' },
        { value: '조', label: '조(燥)', desc: '건조함' },
        { value: '활', label: '활(滑)', desc: '미끄러움' },
    ];

    // ── 맥진 카드 ──
    public pulseTypes = [
        { value: '부', label: '부(浮)', desc: '표증', cat: 'depth' },
        { value: '침', label: '침(沈)', desc: '리증', cat: 'depth' },
        { value: '지', label: '지(遲)', desc: '한증', cat: 'speed' },
        { value: '삭', label: '삭(數)', desc: '열증', cat: 'speed' },
        { value: '활', label: '활(滑)', desc: '담음·임신', cat: 'form' },
        { value: '삽', label: '삽(澀)', desc: '혈허·어혈', cat: 'form' },
        { value: '현', label: '현(弦)', desc: '간담병·통증', cat: 'form' },
        { value: '긴', label: '긴(緊)', desc: '한증·통증', cat: 'form' },
        { value: '세', label: '세(細)', desc: '혈허·습', cat: 'strength' },
        { value: '홍', label: '홍(洪)', desc: '열성병', cat: 'strength' },
        { value: '약', label: '약(弱)', desc: '기혈양허', cat: 'strength' },
        { value: '결', label: '결(結)', desc: '기울·한응', cat: 'rhythm' },
        { value: '대', label: '대(代)', desc: '장기쇠패', cat: 'rhythm' },
        { value: '촉', label: '촉(促)', desc: '양열항성', cat: 'rhythm' },
    ];
    public pulseCats = [
        { key: 'depth', label: '부침' },
        { key: 'speed', label: '지삭' },
        { key: 'form', label: '맥형' },
        { key: 'strength', label: '강약' },
        { key: 'rhythm', label: '율동' },
    ];

    // ── 복진 ──
    public selectedAbdominalRegion: string = '';

    // ── 사상체질 카드 ──
    public constitutionTypes = [
        { value: '태양인', hanja: '太陽人', organ: '폐대간소', desc: '상체 발달, 뒷목 부위 위세 강함, 창의적 진취적', color: '#EF4444' },
        { value: '소양인', hanja: '少陽人', organ: '비대신소', desc: '가슴 발달, 행동 민첩 활발, 성격 급함', color: '#F59E0B' },
        { value: '태음인', hanja: '太陰人', organ: '간대폐소', desc: '허리 발달, 체격 건장, 끈기 인내심', color: '#3B82F6' },
        { value: '소음인', hanja: '少陰人', organ: '신대비소', desc: '하체 발달, 체격 단정, 꼼꼼 세밀', color: '#8B5CF6' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.visitId = WizRoute.segment.visitId;
        if (!this.visitId) {
            this.service.href('/dashboard');
            return;
        }
        await this.load();
        await this.initChat();
        await this.loadRecommendations();
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.abortController) {
            this.abortController.abort();
        }
        this.stopChatResize(true);
    }

    public async load() {
        const { code, data } = await wiz.call('load', { visit_id: this.visitId });
        if (code !== 200) {
            this.service.href('/dashboard');
            return;
        }
        this.visit = data.visit || {};
        this.patient = data.patient || {};
        this.chart = data.chart || {};
        this.history = data.history || [];
        this.prescriptions = data.prescriptions || [];

        this.tongueData = this.parseJson(this.chart.tongue_diagnosis) || { color: '', coating: '', shape: '', moisture: '', notes: '' };
        this.pulseData = this.parseJson(this.chart.pulse_diagnosis) || { left_cun: '', left_guan: '', left_chi: '', right_cun: '', right_guan: '', right_chi: '', overall: '', rate: '', notes: '' };
        this.abdominalData = this.parseJson(this.chart.abdominal_diagnosis) || { epigastric: '', umbilical: '', hypogastric: '', left_flank: '', right_flank: '', tenderness: '', notes: '' };
        this.patternData = this.parseJson(this.chart.pattern_identification) || { primary: '', secondary: '', basis: '' };
        this.rosData = this.parseJson(this.chart.review_of_systems) || {};
        this.bodyPainData = this.rosData.body_pain_map || {};
        this.rebuildSelectedBodyRegions();
    }

    private parseJson(val: any) {
        if (!val) return null;
        if (typeof val === 'object') return val;
        try { return JSON.parse(val); } catch { return null; }
    }

    // ── 탭 데이터 입력 여부 표시 ──
    public hasTabData(tab: string): boolean {
        switch (tab) {
            case 'subjective':
                return !!(this.chart.chief_complaint || this.chart.present_illness || this.chart.past_history || this.chart.diagnosis_code);
            case 'objective': {
                const hasBody = Object.values(this.bodyPainData).some((v: any) => v.selected);
                const hasRos = Object.values(this.rosData).some((v: any) => v && typeof v === 'string' && v.trim());
                return hasBody || hasRos || !!(this.chart.objective_findings);
            }
            case 'tongue':
                return !!(this.tongueData.color || this.tongueData.coating || this.tongueData.shape || this.tongueData.moisture);
            case 'pulse':
                return !!(this.pulseData.overall || this.pulseData.rate || this.pulseData.left_cun || this.pulseData.right_cun);
            case 'abdominal':
                return !!(this.abdominalData.epigastric || this.abdominalData.umbilical || this.abdominalData.hypogastric || this.abdominalData.left_flank || this.abdominalData.right_flank);
            case 'pattern':
                return !!(this.patternData.primary || this.patternData.secondary || this.chart.constitution_type);
            case 'plan':
                return !!(this.chart.treatment_principle || this.chart.treatment_plan || this.chart.notes);
            case 'prescription':
                return this.prescriptions.length > 0;
            default:
                return false;
        }
    }

    public getCompletedTabCount(): number {
        const tabs = this.chartNavigationSections.map((section: any) => section.key);
        return tabs.filter((tab) => this.hasTabData(tab)).length;
    }

    public getProgressSectionCount(): number {
        return this.chartNavigationSections.length;
    }

    public getCompletionPercent(): number {
        const total = this.getProgressSectionCount();
        if (!total) return 0;
        return Math.round((this.getCompletedTabCount() / total) * 100);
    }

    public getActiveTabLabel(): string {
        const labels: any = {
            subjective: '주소증',
            objective: '객관소견',
            tongue: '설진',
            pulse: '맥진',
            abdominal: '복진',
            pattern: '변증',
            plan: '치료계획',
            prescription: '처방'
        };
        return labels[this.chartTab] || '차트';
    }

    public getCurrentChartSectionMeta() {
        return this.chartNavigationSections.find((section: any) => section.key === this.chartTab) || this.chartNavigationSections[0];
    }

    public chartSectionsByGroup(groupKey: string) {
        return this.chartNavigationSections.filter((section: any) => section.group === groupKey);
    }

    public getChartSectionStatusLabel(tab: string): string {
        if (tab === 'prescription') {
            return this.prescriptions.length > 0 ? '입력됨' : '대기';
        }
        return this.hasTabData(tab) ? '입력됨' : '대기';
    }

    public getChartSectionStatusClass(tab: string): string {
        if (tab === this.chartTab) {
            return 'bg-slate-900 text-white';
        }
        if (tab === 'prescription' && this.prescriptions.length > 0) {
            return 'bg-emerald-100 text-emerald-700';
        }
        return this.hasTabData(tab) ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500';
    }

    public getNextPendingSection() {
        return this.chartNavigationSections.find((section: any) => this.getChartSectionStatusLabel(section.key) !== '입력됨') || this.getCurrentChartSectionMeta();
    }

    public openChartNavigator() {
        this.showChartNavigator = true;
        this.service.render();
    }

    public closeChartNavigator() {
        this.showChartNavigator = false;
        this.service.render();
    }

    public selectChartTab(tab: string) {
        this.chartTab = tab;
        this.showChartNavigator = false;
        this.service.render();
    }

    public jumpToNextPendingSection() {
        const next = this.getNextPendingSection();
        if (!next) return;
        this.chartTab = next.key;
        this.showChartNavigator = false;
        this.service.render();
    }

    public getChartStatusLabel(): string {
        const map: any = {
            draft: '작성 중',
            confirmed: '확정 완료',
            finalized: '최종 완료'
        };
        return map[this.chart.status] || '작성 중';
    }

    public getChartStatusClass(): string {
        const map: any = {
            draft: 'bg-slate-100 text-slate-700 ring-1 ring-slate-300',
            confirmed: 'bg-blue-50 text-blue-800 ring-1 ring-blue-200',
            finalized: 'bg-slate-800 text-white ring-1 ring-slate-700'
        };
        return map[this.chart.status] || 'bg-slate-100 text-slate-700 ring-1 ring-slate-300';
    }

    public getCurrentSectionGroupLabel(): string {
        const current = this.getCurrentChartSectionMeta();
        const group = this.chartSectionGroups.find((item: any) => item.key === current?.group);
        return group?.label || '진료기록';
    }

    public getCurrentSectionDescription(): string {
        return this.getCurrentChartSectionMeta()?.description || this.getTabGuideText();
    }

    public startChatResize(event: MouseEvent) {
        if (typeof window === 'undefined' || window.innerWidth < 1280) return;
        event.preventDefault();
        this.chatPanelResizing = true;
        document.body.classList.add('chart-chat-resizing');
        document.addEventListener('mousemove', this.chatResizeMoveHandler);
        document.addEventListener('mouseup', this.chatResizeUpHandler);
    }

    public resetChatPanelWidth() {
        this.applyChatPanelWidth(this.chatPanelDefaultWidth);
        this.service.render();
    }

    public openAiPanel(tab: string = 'recommendations') {
        this.showChat = true;
        this.aiPanelTab = tab;
        this.service.render();
    }

    public closeAiPanel() {
        this.stopChatResize(true);
        this.showChat = false;
        this.service.render();
    }

    private onChatResize(event: MouseEvent) {
        if (!this.chatPanelResizing || typeof window === 'undefined') return;
        this.applyChatPanelWidth(window.innerWidth - event.clientX);
    }

    private applyChatPanelWidth(width: number) {
        this.chatPanelWidth = this.clampChatPanelWidth(width);
        const panel = document.getElementById('chart-ai-panel');
        if (panel) {
            panel.style.width = `${this.chatPanelWidth}px`;
        }
    }

    private clampChatPanelWidth(width: number): number {
        if (typeof window === 'undefined') {
            return Math.max(this.chatPanelMinWidth, Math.round(width));
        }
        const maxWidth = Math.min(560, Math.round(window.innerWidth * 0.52));
        return Math.max(this.chatPanelMinWidth, Math.min(maxWidth, Math.round(width)));
    }

    private stopChatResize(skipRender: boolean = false) {
        document.removeEventListener('mousemove', this.chatResizeMoveHandler);
        document.removeEventListener('mouseup', this.chatResizeUpHandler);
        document.body.classList.remove('chart-chat-resizing');
        if (!this.chatPanelResizing) return;
        this.chatPanelResizing = false;
        if (!skipRender) {
            this.service.render();
        }
    }

    public getVisitStatusLabel(): string {
        const map: any = {
            waiting: '대기',
            intake: '예진 중',
            ready: '진료 대기',
            in_progress: '진료 중',
            charting: '기록 정리',
            prescribing: '처방·후속',
            completed: '완료'
        };
        return map[this.visit.status] || this.visit.status || '진료 중';
    }

    public getVisitStatusClass(): string {
        const map: any = {
            waiting: 'bg-amber-100 text-amber-700',
            intake: 'bg-orange-100 text-orange-700',
            ready: 'bg-emerald-100 text-emerald-700',
            in_progress: 'bg-blue-100 text-blue-700',
            charting: 'bg-indigo-100 text-indigo-700',
            prescribing: 'bg-violet-100 text-violet-700',
            completed: 'bg-emerald-100 text-emerald-700'
        };
        return map[this.visit.status] || 'bg-slate-100 text-slate-600';
    }

    public getVisitTypeLabel(): string {
        const map: any = {
            outpatient: '초진',
            initial: '초진',
            revisit: '재진',
            followup: '재진',
            emergency: '응급',
        };
        return map[this.visit.visit_type] || '재진';
    }

    public getVisitTypeClass(): string {
        const map: any = {
            outpatient: 'bg-sky-50 text-sky-700 ring-1 ring-sky-200',
            initial: 'bg-sky-50 text-sky-700 ring-1 ring-sky-200',
            revisit: 'bg-slate-100 text-slate-700 ring-1 ring-slate-200',
            followup: 'bg-slate-100 text-slate-700 ring-1 ring-slate-200',
            emergency: 'bg-rose-50 text-rose-700 ring-1 ring-rose-200',
        };
        return map[this.visit.visit_type] || 'bg-slate-100 text-slate-700 ring-1 ring-slate-200';
    }

    public getInsuranceLabel(): string {
        const map: any = {
            health: '건강보험',
            medical: '의료급여',
            industrial: '산재',
            auto: '자동차보험',
            self: '비급여',
            NHI: '건강보험',
            MED: '의료급여',
            IND: '산재',
            CAR: '자동차보험',
            SELF: '비급여',
        };
        return map[this.patient.insurance_type] || this.patient.insurance_type || '보험 미확인';
    }

    public getPatientInitials(): string {
        const name = (this.patient.name || '').trim();
        if (!name) return '환';
        if (name.length === 1) return name;
        return name.slice(0, 2);
    }

    public getEncounterHeadline(): string {
        return this.chart.chief_complaint || this.visit.visit_reason || '이번 방문의 핵심 증상과 진료 방향을 정리해 주세요.';
    }

    public getEncounterSupportText(): string {
        return this.visit.memo || this.patient.memo || '추천 패널과 차트 입력을 함께 보며 진료 흐름을 정리할 수 있습니다.';
    }

    public getPatientSignalCount(): number {
        return (this.patient.conditions || []).length + (this.patient.allergies || []).length + (this.patient.medications || []).length;
    }

    public activeSignalItems(limit: number = 4) {
        const items: any[] = [];

        for (const allergy of (this.patient.allergies || [])) {
            items.push({
                kind: 'allergy',
                label: `알레르기 · ${allergy.allergen}`,
                detail: allergy.reaction || allergy.severity || '반응 확인 필요',
                tone: 'rose',
            });
        }

        for (const condition of (this.patient.conditions || [])) {
            items.push({
                kind: 'condition',
                label: `기저질환 · ${condition.condition_name}`,
                detail: condition.severity || condition.treatment_status || '현재 상태 확인',
                tone: 'amber',
            });
        }

        for (const medication of (this.patient.medications || [])) {
            items.push({
                kind: 'medication',
                label: `복용약 · ${medication.medication_name}`,
                detail: medication.frequency || medication.dosage || '복용 계획 확인',
                tone: 'sky',
            });
        }

        return items.slice(0, limit);
    }

    public getHistoryCount(): number {
        return this.history.filter((item: any) => item && item.id !== this.chart.id).length;
    }

    public latestHistoryItem() {
        return this.recentHistory(1)[0] || null;
    }

    public recentHistory(limit: number = 3) {
        return this.history
            .filter((item: any) => item && item.id !== this.chart.id)
            .slice(0, limit);
    }

    public formatShortDate(value: any): string {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return `${value}`.slice(0, 10);
        }
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${month}.${day}`;
    }

    public getHistoryTitle(item: any): string {
        return item?.diagnosis_primary || item?.diagnosis_code || item?.chief_complaint || '이전 진료 기록';
    }

    public getHistorySummary(item: any): string {
        return item?.treatment_plan || item?.present_illness || item?.chief_complaint || '요약된 이전 기록이 없습니다.';
    }

    public recommendationHighlights(limit: number = 4) {
        return [...this.recommendationSections]
            .filter((section: any) => this.recommendationItems(section.key).length > 0)
            .sort((left: any, right: any) => this.recommendationItems(right.key).length - this.recommendationItems(left.key).length)
            .slice(0, limit);
    }

    public conversationCount(): number {
        return this.chatMessages.filter((message: any) => message && (message.role === 'user' || message.role === 'assistant')).length;
    }

    public lastAssistantSnippet(limit: number = 140): string {
        const last = [...this.chatMessages]
            .reverse()
            .find((message: any) => message && message.role === 'assistant' && message.content);

        if (!last?.content) {
            return '추천 기반 질문을 시작하면 대화 기록이 여기에 요약됩니다.';
        }

        const snippet = this.stripJsonBlocks(last.content).replace(/\s+/g, ' ').trim();
        if (!snippet) {
            return '최근 대화는 구조화 제안 위주로 정리되었습니다.';
        }
        return snippet.length > limit ? `${snippet.slice(0, limit)}...` : snippet;
    }

    public pendingAssistantSuggestions(limit: number = 3) {
        return this.chatMessages
            .filter((message: any) => message && message.role === 'assistant' && !message.is_applied && (message._chartUpdate || message.prescription || message.safety))
            .slice(-limit)
            .reverse();
    }

    public currentTabRecommendationCount(): number {
        return this.recommendationItems(this.chartTab).length;
    }

    public primaryAiPanelTab(): string {
        if (this.pendingAssistantSuggestions().length > 0) {
            return 'pending';
        }
        if (this.currentTabRecommendationCount() > 0 || this.recommendationTotalCount() > 0) {
            return 'recommendations';
        }
        return 'chat';
    }

    public primaryAiPanelLabel(): string {
        if (this.pendingAssistantSuggestions().length > 0) {
            return `AI 검토 ${this.pendingAssistantSuggestions().length}건`;
        }
        if (this.currentTabRecommendationCount() > 0) {
            return `AI 보조 ${this.currentTabRecommendationCount()}건`;
        }
        if (this.conversationCount() > 0) {
            return `AI 대화 ${this.conversationCount()}건`;
        }
        return 'AI 보조';
    }

    public primaryAiPanelDescription(): string {
        if (this.pendingAssistantSuggestions().length > 0) {
            return '차트 초안, 처방 제안, 안전성 경고를 한 번에 검토합니다.';
        }

        const currentItems = this.recommendationItems(this.chartTab);
        if (currentItems.length > 0) {
            return currentItems[0].title;
        }

        return this.lastAssistantSnippet(120);
    }

    public getRecommendationRailTitle(): string {
        const map: any = {
            subjective: '주호소를 넓히는 추천',
            objective: '객관소견 보강 추천',
            tongue: '설진 해석 보조',
            pulse: '맥진 해석 보조',
            abdominal: '복진 확인 포인트',
            pattern: '변증 분기 추천',
            plan: '치료계획 점검',
            prescription: '처방 검토 추천',
        };
        return map[this.chartTab] || '현재 탭 추천';
    }

    public getRecommendationRailDescription(): string {
        if (this.hasRecommendationChatDriver()) {
            return '최근 질문과 현재 차트 탭을 함께 반영해 필요한 제안만 우선 노출합니다.';
        }
        return '긴 대화보다 현재 탭에 필요한 질문, 감별 포인트, 검사 제안을 먼저 보여줍니다.';
    }

    public getClinicalPhaseLabel(): string {
        const map: any = {
            recommendation: '추천 중심',
            guide: '초진 가이드',
            inquiry: '문진 진행 중',
            summary: '종합 정리',
            diagnosis: '변증/진단',
            prescription: '처방 제안'
        };
        return map[this.clinicalPhase] || '진료 보조';
    }

    public getClinicalPhaseClass(): string {
        const map: any = {
            recommendation: 'bg-slate-200 text-slate-700',
            guide: 'bg-blue-100 text-blue-800',
            inquiry: 'bg-zinc-100 text-zinc-700',
            summary: 'bg-slate-800 text-white',
            diagnosis: 'bg-slate-200 text-slate-700',
            prescription: 'bg-blue-50 text-blue-800'
        };
        return map[this.clinicalPhase] || 'bg-slate-100 text-slate-600';
    }

    public getTabGuideText(): string {
        const map: any = {
            subjective: '주호소, 현병력, 과거력과 진단 코드를 한 흐름으로 정리합니다.',
            objective: '통증 부위와 이학적 소견을 함께 기록해 감별의 근거를 남깁니다.',
            tongue: '설색, 설태, 설형을 시각적으로 선택해 한눈에 비교합니다.',
            pulse: '맥상과 맥박수를 구조화해 이후 변증의 근거로 연결합니다.',
            abdominal: '복부 분획별 소견을 눌러 기록하고 압통 포인트를 정리합니다.',
            pattern: '변증과 사상체질을 종합해 진단 방향을 명확히 적습니다.',
            plan: '치법, 치료 계획, 교육 내용을 진료 종료 전에 정돈합니다.',
            prescription: '확정된 처방과 시술 계획을 방문 단위로 관리합니다.',
        };
        return map[this.chartTab] || '현재 탭의 진료 기록을 정리합니다.';
    }

    public async saveChart(silent: boolean = false) {
        this.rosData.body_pain_map = this.bodyPainData;
        this.chart.tongue_diagnosis = JSON.stringify(this.tongueData);
        this.chart.pulse_diagnosis = JSON.stringify(this.pulseData);
        this.chart.abdominal_diagnosis = JSON.stringify(this.abdominalData);
        this.chart.pattern_identification = JSON.stringify(this.patternData);
        this.chart.review_of_systems = JSON.stringify(this.rosData);

        const { code } = await wiz.call('save_chart', this.chart);
        if (code === 200 && !silent) {
            await this.service.modal.show({ title: '저장 완료', message: '차트가 저장되었습니다', action: '확인' });
        }
    }

    public async confirmChart() {
        await this.saveChart(true);
        const res = await this.service.modal.show({
            title: '차트 확정', message: '차트를 확정하시겠습니까? 확정 후에도 수정은 가능합니다.',
            action: '확정', cancel: '취소'
        });
        if (res) {
            const { code } = await wiz.call('confirm_chart', { id: this.chart.id });
            if (code === 200) {
                this.chart.status = 'confirmed';
                await this.service.render();
            }
        }
    }

    public async finalizeChart() {
        const res = await this.service.modal.show({
            title: '진료 완료', message: '진료를 최종 완료하시겠습니까?',
            action: '완료', actionBtn: 'bg-green-600', cancel: '취소'
        });
        if (res) {
            const { code } = await wiz.call('finalize_chart', { id: this.chart.id, visit_id: this.visitId });
            if (code === 200) {
                this.service.href('/reception');
            }
        }
    }

    // ── 진단코드 ──
    public async searchDiagnosis() {
        if (this.diagSearch.length < 1) { this.diagResults = []; return; }
        const { code, data } = await wiz.call('search_diagnosis', { text: this.diagSearch });
        if (code === 200) this.diagResults = data;
        await this.service.render();
    }

    public selectDiagnosis(diag: any) {
        this.chart.diagnosis_code = diag.code;
        this.chart.diagnosis_primary = diag.name;
        this.diagResults = [];
        this.diagSearch = '';
        this.service.render();
    }

    // ── 인체 통증 지도 ──
    public toggleBodyRegion(regionId: string) {
        if (!this.bodyPainData[regionId]) {
            this.bodyPainData[regionId] = { selected: true, pain_level: 1, notes: '' };
        } else {
            this.bodyPainData[regionId].selected = !this.bodyPainData[regionId].selected;
        }
        if (this.bodyPainData[regionId].selected) {
            this.selectedBodyRegion = regionId;
        } else if (this.selectedBodyRegion === regionId) {
            this.selectedBodyRegion = '';
        }
        this.rebuildSelectedBodyRegions();
        this.service.render();
    }

    public selectBodyDetail(regionId: string) {
        this.selectedBodyRegion = regionId;
        this.service.render();
    }

    public setBodyPainLevel(regionId: string, level: number) {
        if (!this.bodyPainData[regionId]) return;
        this.bodyPainData[regionId].pain_level = level;
        this.rebuildSelectedBodyRegions();
        this.service.render();
    }

    public updateBodyRegionNote(regionId: string, value: string) {
        if (!this.bodyPainData[regionId]) return;
        this.bodyPainData[regionId].notes = value;
    }

    public isBodyRegionSelected(id: string): boolean {
        return this.bodyPainData[id]?.selected || false;
    }

    public bodyFill(id: string): string {
        if (!this.bodyPainData[id]?.selected) return 'rgba(229,231,235,0.25)';
        const lv = this.bodyPainData[id]?.pain_level || 1;
        if (lv >= 3) return 'rgba(239,68,68,0.45)';
        if (lv >= 2) return 'rgba(251,191,36,0.45)';
        return 'rgba(16,185,129,0.45)';
    }

    public bodyStroke(id: string): string {
        if (this.selectedBodyRegion === id) return '#059669';
        if (this.bodyPainData[id]?.selected) return '#6ee7b7';
        return '#d1d5db';
    }

    public getSelectedBodyRegions(): any[] {
        return this.selectedBodyRegions;
    }

    private rebuildSelectedBodyRegions() {
        this.selectedBodyRegions = Object.entries(this.bodyPainData)
            .filter(([_, value]: any) => value && value.selected)
            .map(([key, value]: any) => ({ id: key, label: this.bodyLabel(key), ...value }));
    }

    public bodyLabel(id: string): string {
        const all = [...this.bodyRegionsFront, ...this.bodyRegionsBack];
        return all.find(r => r.id === id)?.label || id;
    }

    // ── 설진 ──
    public selTongueColor(v: string) { this.tongueData.color = this.tongueData.color === v ? '' : v; this.service.render(); }
    public selTongueCoating(v: string) { this.tongueData.coating = this.tongueData.coating === v ? '' : v; this.service.render(); }
    public selTongueShape(v: string) { this.tongueData.shape = this.tongueData.shape === v ? '' : v; this.service.render(); }
    public selTongueMoisture(v: string) { this.tongueData.moisture = this.tongueData.moisture === v ? '' : v; this.service.render(); }
    public getTongueColorHex(): string { return this.tongueColors.find(c => c.value === this.tongueData.color)?.hex || '#F4A0A0'; }
    public getTongueCoatingHex(): string { const f = this.tongueCoatings.find(c => c.value === this.tongueData.coating); return f ? f.hex : 'transparent'; }

    // ── 맥진 ──
    public togglePulse(position: string, ptype: string) {
        const cur = this.pulseData[position] || '';
        const arr = cur ? cur.split(',').map((t: string) => t.trim()).filter((t: string) => t) : [];
        const idx = arr.indexOf(ptype);
        if (idx >= 0) arr.splice(idx, 1); else arr.push(ptype);
        this.pulseData[position] = arr.join(', ');
        this.service.render();
    }
    public isPulseOn(position: string, ptype: string): boolean {
        return (this.pulseData[position] || '').split(',').map((t: string) => t.trim()).includes(ptype);
    }

    // ── 복진 ──
    public selAbdRegion(id: string) { this.selectedAbdominalRegion = this.selectedAbdominalRegion === id ? '' : id; this.service.render(); }
    public abdLabel(id: string): string {
        const m: any = { epigastric: '상복부(心下)', umbilical: '제부(臍部)', hypogastric: '하복부(少腹)', left_flank: '좌복부', right_flank: '우복부' };
        return m[id] || id;
    }
    public abdFill(id: string): string {
        if (this.selectedAbdominalRegion === id) return 'rgba(16,185,129,0.35)';
        const v = this.abdominalData[id];
        if (v && v.length > 0) return 'rgba(251,191,36,0.25)';
        return 'rgba(229,231,235,0.15)';
    }

    // ── 체질 ──
    public selConstitution(v: string) { this.chart.constitution_type = this.chart.constitution_type === v ? '' : v; this.service.render(); }

    private createEmptyRecommendations() {
        return {
            summary: '',
            additional_questions: [],
            survey_templates: [],
            examinations: [],
            key_items: [],
            branch_directions: [],
            candidate_conditions: [],
        };
    }

    private buildChartSnapshot() {
        return {
            chief_complaint: this.chart.chief_complaint || '',
            present_illness: this.chart.present_illness || '',
            past_history: this.chart.past_history || '',
            diagnosis_primary: this.chart.diagnosis_primary || '',
            diagnosis_code: this.chart.diagnosis_code || '',
            constitution_type: this.chart.constitution_type || '',
            treatment_plan: this.chart.treatment_plan || '',
            chart_status: this.chart.status || '',
            active_tab: this.chartTab,
            review_of_systems: this.rosData || {},
            tongue_diagnosis: this.tongueData || {},
            pulse_diagnosis: this.pulseData || {},
            abdominal_diagnosis: this.abdominalData || {},
            pattern_identification: this.patternData || {},
        };
    }

    public recommendationItems(sectionKey: string) {
        return this.recommendationPanel?.[sectionKey] || [];
    }

    public recommendationId(sectionKey: string, item: any) {
        return `${sectionKey}:${item?.title || item?.label || item?.name || ''}`;
    }

    public isRecommendationSelected(sectionKey: string, item: any) {
        return this.selectedRecommendationIds.includes(this.recommendationId(sectionKey, item));
    }

    public toggleRecommendationFocus(sectionKey: string, item: any) {
        const id = this.recommendationId(sectionKey, item);
        if (this.selectedRecommendationIds.includes(id)) {
            this.selectedRecommendationIds = this.selectedRecommendationIds.filter((value) => value !== id);
        } else {
            this.selectedRecommendationIds = [...this.selectedRecommendationIds, id];
        }
        this.service.render();
    }

    public clearRecommendationFocus() {
        this.selectedRecommendationIds = [];
        this.service.render();
    }

    public selectedRecommendationDetails() {
        const result: any[] = [];
        for (const section of this.recommendationSections) {
            for (const item of this.recommendationItems(section.key)) {
                const id = this.recommendationId(section.key, item);
                if (!this.selectedRecommendationIds.includes(id)) continue;
                result.push({
                    id,
                    sectionKey: section.key,
                    sectionLabel: section.label,
                    title: item.title,
                    reason: item.reason || '',
                    evidence: item.evidence || '',
                    suggested_prompt: item.suggested_prompt || '',
                    item,
                });
            }
        }
        return result;
    }

    private buildRecommendationContext() {
        const selected = this.selectedRecommendationDetails().map((row: any) => ({
            category: row.sectionLabel,
            title: row.title,
            reason: row.reason,
            evidence: row.evidence,
            suggested_prompt: row.suggested_prompt,
        }));
        return {
            mode: 'chat_first_with_chart_grounding',
            selected,
            recent_chat: this.recommendationChatContext,
        };
    }

    private compactRecommendationText(content: string, limit: number = 320) {
        const plain = this.stripJsonBlocks(content || '').replace(/\s+/g, ' ').trim();
        return plain.slice(0, limit);
    }

    private buildRecentChatThread(limit: number = 8) {
        return this.chatMessages
            .filter((msg: any) => msg && (msg.role === 'user' || msg.role === 'assistant'))
            .map((msg: any) => ({
                role: msg.role,
                content: this.compactRecommendationText(msg.content || '', msg.role === 'user' ? 220 : 360),
            }))
            .filter((msg: any) => msg.content)
            .slice(-limit);
    }

    private refreshRecommendationChatContext(overrides: any = {}) {
        const conversation = this.buildRecentChatThread();
        const reversed = [...conversation].reverse();
        const lastUser = reversed.find((msg: any) => msg.role === 'user');
        const lastAssistant = reversed.find((msg: any) => msg.role === 'assistant');

        this.recommendationChatContext = {
            priority: 'chat_first',
            active_tab: this.chartTab,
            conversation,
            last_user_message: (overrides.last_user_message || lastUser?.content || '').slice(0, 300),
            last_ai_response: (overrides.last_ai_response || lastAssistant?.content || '').slice(0, 1000),
            last_phase: overrides.last_phase || this.recommendationChatContext?.last_phase || this.clinicalPhase || '',
        };
    }

    public hasRecommendationChatDriver() {
        return !!this.recommendationChatContext?.last_user_message;
    }

    public recommendationDriverText() {
        const text = this.recommendationChatContext?.last_user_message || '';
        if (!text) return '차트와 환자 맥락 기준';
        return text.length > 48 ? `${text.slice(0, 48)}...` : text;
    }

    public recommendationTotalCount() {
        return this.recommendationSections.reduce((count: number, section: any) => {
            return count + this.recommendationItems(section.key).length;
        }, 0);
    }

    public recommendationBadge(item: any) {
        return item.priority || item.confidence || '';
    }

    public recommendationPreview(item: any) {
        return item.reason || item.evidence || item.next_focus || item.method || '';
    }

    public recommendationDetail(item: any) {
        if (Array.isArray(item.items) && item.items.length > 0) {
            return item.items.join(', ');
        }
        if (item.next_focus) return item.next_focus;
        if (item.method) return item.method;
        if (item.if_true || item.if_false) {
            return `예: ${item.if_true || '-'} / 아니오: ${item.if_false || '-'}`;
        }
        if (item.suggested_prompt) return item.suggested_prompt;
        return item.evidence || '';
    }

    public async useRecommendationPrompt(sectionKey: string, item: any) {
        if (!this.isRecommendationSelected(sectionKey, item)) {
            this.toggleRecommendationFocus(sectionKey, item);
        }
        if (item.suggested_prompt) {
            this.chatInput = item.suggested_prompt;
        } else {
            this.chatInput = `${item.title} 중심으로 근거와 감별 포인트를 정리해줘.`;
        }
        this.showChat = true;
        this.aiPanelTab = 'chat';
        this.showChatTranscript = true;
        this.recommendationNotice = '선택한 추천을 대화 입력창에 초안으로 채웠습니다.';
        await this.service.render();
    }

    public async loadRecommendations() {
        if (!this.patient?.id) return;
        const requestVersion = ++this.recommendationRequestVersion;
        this.recommendationLoading = true;
        this.recommendationNotice = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('recommendations', {
                visit_id: this.visitId,
                patient_id: this.patient.id,
                chart_id: this.chart.id || '',
                chart_snapshot: JSON.stringify(this.buildChartSnapshot()),
                recommendation_context: JSON.stringify(this.buildRecommendationContext())
            });

            if (requestVersion !== this.recommendationRequestVersion) return;

            if (code === 200) {
                this.recommendationPanel = { ...this.createEmptyRecommendations(), ...(data.recommendations || {}) };
                this.recommendationNotice = data.notice || '';

                const availableIds: string[] = [];
                for (const section of this.recommendationSections) {
                    for (const item of this.recommendationItems(section.key)) {
                        availableIds.push(this.recommendationId(section.key, item));
                    }
                }
                this.selectedRecommendationIds = this.selectedRecommendationIds.filter((id) => availableIds.includes(id));
            } else {
                this.recommendationPanel = this.createEmptyRecommendations();
            }
        } catch (e) {
            if (requestVersion !== this.recommendationRequestVersion) return;
            this.recommendationPanel = this.createEmptyRecommendations();
            this.recommendationNotice = '추천 패널을 갱신하지 못했습니다.';
        }

        if (requestVersion !== this.recommendationRequestVersion) return;
        this.recommendationLoading = false;
        await this.service.render();
    }

    // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    // AI Chat — SSE Streaming
    // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

    public async initChat() {
        const { code, data } = await wiz.call('chat_init', {
            visit_id: this.visitId, patient_id: this.patient.id, chart_id: this.chart.id
        });
        if (code === 200) {
            this.chatSession = data.session;
            this.chatMessages = (data.messages || []).map((m: any) => {
                const mapped: any = {
                    ...m,
                    renderedContent: this.renderMarkdown(this.stripJsonBlocks(m.content || ''))
                };
                if (m.metadata) {
                    try {
                        const meta = typeof m.metadata === 'string' ? JSON.parse(m.metadata) : m.metadata;
                        if (meta.chart_update) {
                            mapped._chartUpdate = meta.chart_update;
                        }
                        if (meta.prescription) {
                            mapped.prescription = meta.prescription;
                            mapped.prescription._messageId = m.id;
                        }
                        if (meta.safety) {
                            mapped.safety = meta.safety;
                        }
                    } catch (e) { /* skip */ }
                }
                return mapped;
            });
            this.refreshRecommendationChatContext();
        }
    }

    public async sendChat() {
        if (!this.chatInput.trim() || !this.chatSession || this.chatLoading) return;
        const msg = this.chatInput.trim();
        this.chatInput = '';
        this.chatLoading = true;
        this.showChat = true;
        this.aiPanelTab = 'chat';
        this.showChatTranscript = true;
        this.streamingContent = '';
        let shouldRefreshRecommendations = false;
        let latestRecommendationAiText = '';
        let latestRecommendationPhase = '';

        // 사용자 메시지 추가
        this.chatMessages.push({
            role: 'user', content: msg, message_type: 'text',
            renderedContent: this.escapeHtml(msg),
            created_at: new Date().toISOString()
        });
        this.refreshRecommendationChatContext({
            last_user_message: msg.slice(0, 300),
            last_phase: this.clinicalPhase,
        });
        this.loadRecommendations();

        // 스트리밍 AI 메시지 placeholder
        const aiMsg: any = {
            role: 'assistant', content: '', message_type: 'text',
            renderedContent: '', streaming: true,
            created_at: new Date().toISOString()
        };
        this.chatMessages.push(aiMsg);
        await this.service.render();
        this.scrollChatBottom();

        // SSE fetch
        this.abortController = new AbortController();
        const formData = new FormData();
        formData.append('session_id', this.chatSession.id);
        formData.append('message', msg);
        formData.append('chart_id', this.chart.id || '');
        formData.append('chart_snapshot', JSON.stringify(this.buildChartSnapshot()));
        formData.append('recommendation_context', JSON.stringify(this.buildRecommendationContext()));

        try {
            const response = await fetch(
                `/wiz/api/page.chart/chat_send`,
                { method: 'POST', body: formData, signal: this.abortController.signal }
            );

            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            let fullText = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const parts = buffer.split('\n\n');
                buffer = parts.pop() || '';

                for (const part of parts) {
                    if (!part.startsWith('data: ')) continue;
                    try {
                        const event = JSON.parse(part.slice(6));

                        if (event.type === 'delta') {
                            fullText += event.content;
                            aiMsg.content = fullText;
                            const display = this.stripJsonBlocks(fullText);
                            aiMsg.renderedContent = this.renderMarkdown(display);
                            await this.service.render();
                            this.scrollChatBottom();
                        }

                        if (event.type === 'done') {
                            aiMsg.streaming = false;
                            aiMsg.id = event.message_id;
                            aiMsg.message_type = event.message_type;

                            // 진료 단계 업데이트
                            if (event.phase) {
                                this.clinicalPhase = event.phase;
                                latestRecommendationPhase = event.phase;
                            }

                            // 차트 기록 제안
                            if (event.chart_update && Object.keys(event.chart_update).length > 0) {
                                aiMsg._chartUpdate = { ...event.chart_update };
                                this.chartUpdateNotice = 'AI가 차트 기록 초안을 제안했습니다. 적용 여부를 선택하세요.';
                                if (this.chartUpdateTimer) clearTimeout(this.chartUpdateTimer);
                                this.chartUpdateTimer = setTimeout(() => {
                                    this.chartUpdateNotice = '';
                                    this.service.render();
                                }, 4000);
                            }

                            // 처방 제안
                            if (event.prescription) {
                                aiMsg.prescription = event.prescription;
                                aiMsg.prescription._messageId = event.message_id;
                            }

                            // 안전성 경고
                            if (event.safety) {
                                aiMsg.safety = event.safety;
                            }

                            latestRecommendationAiText = this.stripJsonBlocks(fullText).trim();
                            shouldRefreshRecommendations = true;
                        }
                    } catch (e) {
                        // skip parse error
                    }
                }
            }
        } catch (e: any) {
            if (e.name !== 'AbortError') {
                aiMsg.content = '응답을 받지 못했습니다.';
                aiMsg.renderedContent = '<p class="text-red-400">응답을 받지 못했습니다.</p>';
            }
        }

        aiMsg.streaming = false;
        this.chatLoading = false;
        this.abortController = null;

        if (shouldRefreshRecommendations) {
            this.refreshRecommendationChatContext({
                last_user_message: msg.slice(0, 300),
                last_ai_response: latestRecommendationAiText,
                last_phase: latestRecommendationPhase || this.clinicalPhase,
            });
            await this.loadRecommendations();
        }

        await this.service.render();
        this.scrollChatBottom();
    }

    public cancelStream() {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
            this.chatLoading = false;
            this.service.render();
        }
    }

    private async applyChartUpdate(updates: any) {
        const fields = Object.keys(updates);
        if (fields.length === 0) return;

        // JSON 객체형 필드 처리
        const jsonFields: any = {
            'tongue_diagnosis': 'tongueData',
            'pulse_diagnosis': 'pulseData',
            'abdominal_diagnosis': 'abdominalData',
            'pattern_identification': 'patternData',
            'review_of_systems': 'rosData'
        };

        for (const [key, val] of Object.entries(updates)) {
            if (key in jsonFields) {
                const prop = (jsonFields as any)[key];
                let parsed: any = val;
                if (typeof val === 'string') {
                    try { parsed = JSON.parse(val); } catch { parsed = key === 'pattern_identification' ? { primary: val as string, secondary: '', basis: '' } : val; }
                }
                if (typeof parsed === 'object' && parsed !== null) {
                    // 기존 데이터와 병합 (빈 값은 덮어쓰지 않음)
                    const current = (this as any)[prop] || {};
                    for (const [k, v] of Object.entries(parsed)) {
                        if (v !== '' && v !== null && v !== undefined) {
                            current[k] = v;
                        }
                    }
                    (this as any)[prop] = current;
                }
                // chart 객체에도 JSON 문자열로 반영 (저장용)
                (this.chart as any)[key] = JSON.stringify((this as any)[prop]);
            } else {
                (this.chart as any)[key] = val;
            }
        }
        await this.saveChart(true);
        await this.load();

        // 차트 업데이트 토스트 알림
        const fieldNames: any = {
            chief_complaint: '주소증', present_illness: '현병력', diagnosis_primary: '진단명',
            diagnosis_code: '진단코드', treatment_principle: '치법', treatment_plan: '치료계획',
            constitution_type: '사상체질', pattern_identification: '변증', notes: '비고',
            tongue_diagnosis: '설진', pulse_diagnosis: '맥진', abdominal_diagnosis: '복진',
            review_of_systems: '객관소견'
        };
        const updated = fields.map(f => fieldNames[f] || f).join(', ');
        this.chartUpdateNotice = `차트 업데이트: ${updated}`;
        if (this.chartUpdateTimer) clearTimeout(this.chartUpdateTimer);
        this.chartUpdateTimer = setTimeout(() => {
            this.chartUpdateNotice = '';
            this.service.render();
        }, 4000);
        await this.service.render();
    }

    public async applyPrescription(presc: any) {
        try {
            const { code } = await wiz.call('chat_apply', {
                message_id: presc._messageId, chart_id: this.chart.id, feedback: 'accepted'
            });
            if (code === 200) {
                // 처방 제안 카드 숨김 (is_applied 설정)
                const msg = this.chatMessages.find((m: any) => m.prescription === presc);
                if (msg) {
                    msg.is_applied = true;
                    msg.feedback = 'accepted';
                }
                await this.load();
                await this.service.modal.show({ title: '처방 적용', message: 'AI 제안 처방이 등록되었습니다', action: '확인' });
            } else {
                await this.service.modal.show({ title: '오류', message: '처방 등록에 실패했습니다.', action: '확인' });
            }
        } catch (e) {
            await this.service.modal.show({ title: '오류', message: '처방 등록 중 오류가 발생했습니다.', action: '확인' });
        }
        await this.service.render();
    }

    public async applyAiSuggestion(msg: any, feedback: string) {
        const { code } = await wiz.call('chat_apply', { message_id: msg.id, chart_id: this.chart.id, feedback });
        if (code === 200 && feedback === 'accepted') {
            await this.load();
            await this.loadRecommendations();
        }
        msg.is_applied = true;
        msg.feedback = feedback;
        await this.service.render();
    }

    // ── 수정(Modify) 플로우 ──
    private fieldNameMap: any = {
        chief_complaint: '주소증', present_illness: '현병력', diagnosis_primary: '진단명',
        diagnosis_code: '진단코드', treatment_principle: '치법', treatment_plan: '치료계획',
        constitution_type: '사상체질', notes: '비고', objective_findings: '이학적 검사'
    };

    public openModifyChart(msg: any) {
        if (!msg._chartUpdate) return;
        this.modifyMsg = msg;
        this.modifyFields = {};
        this.modifyFieldKeys = [];
        for (const [key, val] of Object.entries(msg._chartUpdate)) {
            this.modifyFields[key] = val;
            this.modifyFieldKeys.push(key);
        }
        this.showModifyModal = true;
        this.service.render();
    }

    public getFieldLabel(key: string): string {
        return this.fieldNameMap[key] || key;
    }

    public async applyModifiedChart() {
        if (!this.modifyMsg) return;
        const modData = { chart_update: this.modifyFields };
        const { code } = await wiz.call('chat_apply', {
            message_id: this.modifyMsg.id,
            chart_id: this.chart.id,
            feedback: 'modified',
            modified_data: JSON.stringify(modData)
        });
        if (code === 200) {
            await this.load();
            await this.loadRecommendations();
            this.modifyMsg.is_applied = true;
            this.modifyMsg.feedback = 'modified';
            this.chartUpdateNotice = '수정된 내용이 차트에 적용되었습니다';
            if (this.chartUpdateTimer) clearTimeout(this.chartUpdateTimer);
            this.chartUpdateTimer = setTimeout(() => { this.chartUpdateNotice = ''; this.service.render(); }, 4000);
        }
        this.showModifyModal = false;
        this.modifyMsg = null;
        await this.service.render();
    }

    public closeModifyModal() {
        this.showModifyModal = false;
        this.modifyMsg = null;
        this.service.render();
    }

    public modifyPrescription(msg: any) {
        if (!msg.prescription) return;
        const p = msg.prescription;
        this.prescForm = {
            prescription_name: p.prescription_name || '',
            prescription_type: p.prescription_type || 'herbal',
            total_days: p.total_days || 7,
            daily_doses: p.daily_doses || 3,
            preparation_method: p.preparation_method || 'decoction',
            herbs: (p.herbs || []).map((h: any) => ({ ...h })),
            acupoints: (p.acupoints || []).map((a: any) => ({ ...a })),
            instructions: p.instructions || '',
            _fromAi: true,
            _messageId: p._messageId || msg.id
        };
        this.showPrescription = true;
        this.service.render();
    }

    // ── 마크다운 렌더링 ──
    private renderMarkdown(text: string): string {
        if (!text) return '';
        let html = this.escapeHtml(text);

        // 코드블록 (```...```) — JSON 블록은 이미 strip 됨
        html = html.replace(/```(\w*)\n([\s\S]*?)```/g, '<pre class="chat-code"><code>$2</code></pre>');

        // 인라인 코드
        html = html.replace(/`([^`]+)`/g, '<code class="chat-inline-code">$1</code>');

        // 표 (| ... | ... |) — 간단한 파싱
        html = this.renderTables(html);

        // 헤딩
        html = html.replace(/^### (.+)$/gm, '<h4 class="chat-h4">$1</h4>');
        html = html.replace(/^## (.+)$/gm, '<h3 class="chat-h3">$1</h3>');
        html = html.replace(/^# (.+)$/gm, '<h2 class="chat-h2">$1</h2>');

        // 볼드/이탤릭
        html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
        html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');

        // 리스트 (unordered)
        html = html.replace(/^[-•·]\s+(.+)$/gm, '<li class="chat-li">$1</li>');
        html = html.replace(/((?:<li class="chat-li">.*<\/li>\n?)+)/g, '<ul class="chat-ul">$1</ul>');

        // 번호 리스트
        html = html.replace(/^\d+\.\s+(.+)$/gm, '<li class="chat-oli">$1</li>');
        html = html.replace(/((?:<li class="chat-oli">.*<\/li>\n?)+)/g, '<ol class="chat-ol">$1</ol>');

        // 수평선
        html = html.replace(/^---+$/gm, '<hr class="chat-hr">');

        // 줄바꿈
        html = html.replace(/\n/g, '<br>');

        // br 정리 (블록 태그 전후)
        html = html.replace(/<br>\s*(<(?:h[2-4]|ul|ol|pre|hr|table))/g, '$1');
        html = html.replace(/(<\/(?:h[2-4]|ul|ol|pre|hr|table)>)\s*<br>/g, '$1');

        return html;
    }

    private renderTables(html: string): string {
        const lines = html.split('\n');
        let result: string[] = [];
        let tableLines: string[] = [];
        let inTable = false;

        for (const line of lines) {
            if (line.trim().startsWith('|') && line.trim().endsWith('|')) {
                tableLines.push(line);
                inTable = true;
            } else {
                if (inTable) {
                    result.push(this.buildTable(tableLines));
                    tableLines = [];
                    inTable = false;
                }
                result.push(line);
            }
        }
        if (inTable) result.push(this.buildTable(tableLines));

        return result.join('\n');
    }

    private buildTable(lines: string[]): string {
        if (lines.length < 2) return lines.join('\n');
        let tbl = '<table class="chat-table"><thead><tr>';
        const headers = lines[0].split('|').filter(c => c.trim());
        for (const h of headers) tbl += `<th>${h.trim()}</th>`;
        tbl += '</tr></thead><tbody>';
        for (let i = 2; i < lines.length; i++) {
            const cells = lines[i].split('|').filter(c => c.trim());
            if (cells.length === 0) continue;
            tbl += '<tr>';
            for (const c of cells) tbl += `<td>${c.trim()}</td>`;
            tbl += '</tr>';
        }
        tbl += '</tbody></table>';
        return tbl;
    }

    private stripJsonBlocks(text: string): string {
        let result = text;

        // 1. ```json ... ``` 코드블록 중 chart_update / prescription / recommendations 포함된 것 제거
        result = result.replace(/```json\s*\n?[\s\S]*?```/g, (match) => {
            if (/(?:"chart_update|prescription|recommendations)"/.test(match)) return '';
            return match;
        });

        // 2. bare JSON 객체 제거
        result = this.stripBareJsonBlocks(result, 'chart_update');
        result = this.stripBareJsonBlocks(result, 'prescription');
        result = this.stripBareJsonBlocks(result, 'recommendations');

        // 3. 스트리밍 중 불완전한 ```json 블록 숨기기 (닫는 ``` 없는 경우)
        const incompleteIdx = result.lastIndexOf('```json');
        if (incompleteIdx >= 0) {
            const afterMarker = result.substring(incompleteIdx + 7);
            if (afterMarker.indexOf('```') === -1) {
                result = result.substring(0, incompleteIdx);
            }
        }

        // 4. 스트리밍 중 불완전한 bare JSON 숨기기
        const bareMatch = result.match(/\n?\s*\{\s*"(?:chart_update|prescription|recommendations)"[\s\S]*$/);
        if (bareMatch) {
            const jsonStart = result.length - bareMatch[0].length;
            // balanced brace 체크 — 불완전하면 제거
            const end = this.findMatchingBrace(result, jsonStart + bareMatch[0].indexOf('{'));
            if (end === -1) {
                result = result.substring(0, jsonStart);
            }
        }

        return result.trim();
    }

    private stripBareJsonBlocks(text: string, key: string): string {
        const pattern = new RegExp(`\\{\\s*"${key}"\\s*:`, 'g');
        let result = text;
        let m;
        let offset = 0;
        // reset lastIndex
        pattern.lastIndex = 0;
        const tempText = text; // search on original
        while ((m = pattern.exec(tempText)) !== null) {
            const start = m.index - offset;
            const end = this.findMatchingBrace(result, start);
            if (end > start) {
                result = result.substring(0, start) + result.substring(end);
                offset += (end - start);
            }
        }
        return result;
    }

    private findMatchingBrace(text: string, start: number): number {
        let depth = 0;
        let inString = false;
        let escape = false;
        for (let i = start; i < text.length; i++) {
            const ch = text[i];
            if (escape) { escape = false; continue; }
            if (ch === '\\' && inString) { escape = true; continue; }
            if (ch === '"' && !escape) { inString = !inString; continue; }
            if (inString) continue;
            if (ch === '{') depth++;
            else if (ch === '}') {
                depth--;
                if (depth === 0) return i + 1;
            }
        }
        return -1; // unmatched
    }

    private escapeHtml(text: string): string {
        return text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    private scrollChatBottom() {
        setTimeout(() => {
            const el = document.getElementById('chat-messages');
            if (el) el.scrollTop = el.scrollHeight;
        }, 50);
    }

    // ── 처방 ──
    public openPrescription(presc?: any) {
        this.showPrescription = true;
        if (presc) {
            this.prescForm = { ...presc };
            if (typeof this.prescForm.herbs === 'string') { try { this.prescForm.herbs = JSON.parse(this.prescForm.herbs); } catch { this.prescForm.herbs = []; } }
            if (!this.prescForm.herbs) this.prescForm.herbs = [];
            if (typeof this.prescForm.acupoints === 'string') { try { this.prescForm.acupoints = JSON.parse(this.prescForm.acupoints); } catch { this.prescForm.acupoints = []; } }
            if (!this.prescForm.acupoints) this.prescForm.acupoints = [];
        } else {
            this.prescForm = {
                visit_id: this.visitId, patient_id: this.patient.id, doctor_id: this.visit.doctor_id, chart_id: this.chart.id,
                prescription_type: 'herbal', prescription_name: '', total_days: 7, daily_doses: 3,
                preparation_method: 'decoction', instructions: '', herbs: [], acupoints: []
            };
        }
        this.service.render();
    }
    public closePrescription() { this.showPrescription = false; this.service.render(); }

    public async searchHerb() {
        if (this.herbSearch.length < 1) { this.herbResults = []; return; }
        const { code, data } = await wiz.call('search_herb', { text: this.herbSearch });
        if (code === 200) this.herbResults = data;
        await this.service.render();
    }
    public addHerb(herb: any) {
        this.prescForm.herbs.push({ herb_name: herb.name || herb.name_korean, dosage: herb.dosage_range || '8', unit: 'g', role: '신', processing_method: '', sort_order: this.prescForm.herbs.length + 1 });
        this.herbSearch = ''; this.herbResults = []; this.service.render();
    }
    public removeHerb(i: number) { this.prescForm.herbs.splice(i, 1); this.service.render(); }

    public async searchAcupoint() {
        if (this.acupointSearch.length < 1) { this.acupointResults = []; return; }
        const { code, data } = await wiz.call('search_acupoint', { text: this.acupointSearch });
        if (code === 200) this.acupointResults = data;
        await this.service.render();
    }
    public addAcupoint(ap: any) {
        this.prescForm.acupoints.push({ acupoint_code: ap.code, acupoint_name: ap.name || ap.name_korean, meridian: ap.meridian, side: 'bilateral', method: 'needling', stimulation: '평보평사' });
        this.acupointSearch = ''; this.acupointResults = []; this.service.render();
    }
    public removeAcupoint(i: number) { this.prescForm.acupoints.splice(i, 1); this.service.render(); }

    public async savePrescription() {
        const params = { ...this.prescForm };
        const isFromAi = params._fromAi;
        const aiMessageId = params._messageId;
        delete params._fromAi;
        delete params._messageId;
        params.herbs = JSON.stringify(params.herbs || []);
        params.acupoints = JSON.stringify(params.acupoints || []);
        const { code } = await wiz.call('save_prescription', params);
        if (code === 200) {
            if (isFromAi && aiMessageId) {
                await wiz.call('chat_apply', {
                    message_id: aiMessageId,
                    chart_id: this.chart.id,
                    feedback: 'modified',
                    modified_data: JSON.stringify({ prescription: params })
                });
                const msg = this.chatMessages.find((m: any) => m.prescription?._messageId === aiMessageId);
                if (msg) { msg.is_applied = true; msg.feedback = 'modified'; }
            }
            this.closePrescription();
            await this.load();
        }
    }
    public async deletePrescription(presc: any) {
        const res = await this.service.modal.show({ title: '처방 삭제', message: '이 처방을 삭제하시겠습니까?', action: '삭제', actionBtn: 'bg-red-500', cancel: '취소' });
        if (res) { await wiz.call('delete_prescription', { id: presc.id }); await this.load(); }
    }

    // ── 유틸 ──
    public getChartUpdateSummary(updates: any) {
        if (!updates) return '';
        return Object.keys(updates).map((key) => this.getFieldLabel(key)).join(', ');
    }

    public getAge(bd: string) { if (!bd) return '-'; return Math.floor((Date.now() - new Date(bd).getTime()) / (365.25 * 24 * 60 * 60 * 1000)) + '세'; }
    public getGenderLabel(g: string) { return g === 'M' ? '남' : g === 'F' ? '여' : '-'; }
}

export default PageChartComponent;